import React from 'react'
import './ModeratorPlayerCard.css'
import ButtonWithIcon from "../Utils/ButtonWithIcon";
import small_button_bg from "../../images/small_button_bg.svg";
import close_card from "../../images/icons/close_card.svg";
import {ROLE_COLORS, ROLE_NAMES} from "../../constants/Constants";
import {useDrag, useDrop} from "react-dnd";
import ModeratorRoleItem from "./ModeratorRoleItem";

const ModeratorPlayerCard = props => {
    const [, drop] = useDrop(
        () => ({
            accept: "role-drop",
            drop: props.onDrop,
            collect: (monitor) => ({
                isOver: monitor.isOver(),
                canDrop: monitor.canDrop()
            })
        }),
        ['role-drop', props.onDrop]
    );
    const [, drag] = useDrag(() => ({
            item: {
                id: props.id,
                teamFromID: props.teamFromID,
                type: "user-drop",
            },
            collect: (monitor) => ({
                isDragging: !monitor.isDragging()
            })
        })
        , [props.role, "user-drop"]);

    let roleStatus = []
    let roles = props.player.role;
    if (roles) {
        for (let i = 0; i < roles.length; i++) {
            let content = <>
                <div className='moderator-player-card-role-color' title={ROLE_NAMES[roles[i]]}
                     style={{background: ROLE_COLORS[roles[i]]}}/>
                <div className='moderator-player-card-role-text'/>
            </>

            roleStatus.push(<ModeratorRoleItem id={props.id} uuid={props.player.uuid} role={roles[i]} key={i}
                                               content={content}/>)
        }
    }

    return <div className='moderator-team-player-card-container' ref={drop}>
        <div className="moderator-team-player-card" ref={drag}>
            <div className='moderator-player-card-title'>
                {`${props.player.firstname} ${props.player.lastname}`}
            </div>
            {roleStatus}
            {props.isEditable ?
                <div className="moderator-player-card-close-button">
                    <ButtonWithIcon onClick={() => {
                        props.onRemovePlayer(props.player)
                    }}
                                    background={small_button_bg}
                                    icon={close_card}
                                    bgColor="#FFFFFF"
                                    bgColorHover='#FFFFFF'
                                    bgColorActive='#FFFFFF'
                                    size={18}/>
                </div> :
                ""}
        </div>
    </div>
}

export default ModeratorPlayerCard;
